/** @example
 * ```typescript
 * declare const foo: 'a' | 'b';
 *
 * switch (foo) {
 *    case 'a':
 *    case 'b':
 *        return 'something';
 *    default:
 *        ASSERT_UNREACHABLE(foo);
 * }
 * ```
 */
export function ASSERT_UNREACHABLE(switchedValue: never): never {
    void switchedValue;
    ERROR_UNREACHABLE();
}

export function ERROR_UNREACHABLE(): never {
    throw new Error('UNREACHABLE');
}
